import { Component, OnInit } from "@angular/core";
import { Injectable, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  UntypedFormArray,
  UntypedFormBuilder,
} from "@angular/forms";
import { DaoService } from "./../../services/dao.service";
import { Router } from "@angular/router";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "app-entity",
  templateUrl: "./entity.component.html",
  styleUrls: ["./entity.component.scss"],
})
export class EntityComponent implements OnInit {
  [x: string]: any;
  dataSource: any;
  entityList: any;
  private paginator: MatPaginator;
  // tslint:disable-next-line: variable-name
  public created_By: any;
  displayedColumns: string[] = ["name", "Description", "Edit", "delete"];
  public validator = {
    errorMessage: "",
    UniqueEntity: false,
  };
  public shown = {
    grid: true,
    Form: false,
  };

  public entityEdit = {
    edit: false,
  };

  Entity = new FormGroup({
    entityId: new FormControl(),
    name: new FormControl(),
    description: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    // this.setDataSourceEntity();
  }
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private router: Router,
    private daoService: DaoService,
    private formBuilder: UntypedFormBuilder,
    private token: LstorageService
  ) {
    this.daoService.getEntityList().subscribe(
      (data: any) => {
        this.entityList = data;
        this.dataSource = new MatTableDataSource(this.entityList);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.log("Error: " + error);
      }
    );
  }
  ngOnInit() {
    this.created_By = jwtDecode(this.token.getToken());
    this.Entity = this.fb.group({
      entityId: [""],
      name: ["", [Validators.required]],
      description: [""],
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2019-10-05T03:47:43.629Z"],
      modifiedBy: [],
      modifiedOn: ["2019-10-10T11:17:51.838Z"],
    });
  }

  setDataSourceEntity() {
    this.setDataSourceEntity();
    this.dataSource.paginator = this.paginator;
  }
  EntityForm() {
    this.entityEdit.edit = false;
    this.shown.grid = false;
    this.shown.Form = true;
    this.Entity = this.fb.group({
      entityId: [""],
      name: ["", [Validators.required]],
      description: [""],
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2019-10-05T03:47:43.629Z"],
      modifiedBy: [],
      modifiedOn: ["2019-10-10T11:17:51.838Z"],
    });
  }

  createEntity() {
    this.Entity.value.name = this.Entity.value.name.trim();
    this.validator.UniqueEntity = false;
    this.daoService.AddEntity(this.Entity.value).subscribe(
      (data) => {
        this.backentityList();
      },
      (error) => {
        this.validator.UniqueEntity = true;
        this.validator.errorMessage = error.error.userMessage;
      }
    );
  }

  editEntity(id) {
    this.shown.grid = false;
    this.shown.Form = true;
    this.entityEdit.edit = true;
    this.daoService.getEntityById(id).subscribe((data: any) => {
      this.Entity = this.fb.group({
        entityId: [id],
        name: [data.name, [Validators.required]],
        description: [data.description],
        modifiedBy: [this.created_By.unique_name],
      });
    });
  }

  deleteEntity(id, index) {
    this.daoService.deleteEntityById(id).subscribe((data: any) => {
      this.entityList = this.removeFromArrayOfHash(
        this.entityList,
        "entityId",
        data.data.entityId
      );
      // this.apiListofData = this.apiListofData.splice(0, index);
      this.dataSource = new MatTableDataSource(this.entityList);
      this.dataSource.paginator = this.paginator;
    });
  }
  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter((l_cur_row) => {
      return l_cur_row[p_key] != p_value_to_remove;
    });
  }

  backentityList() {
    this.shown.grid = true;
    this.shown.Form = false;
    this.validator.UniqueEntity = false;
    this.daoService.getEntityList().subscribe(
      (data: any) => {
        this.entityList = data;
        this.dataSource = new MatTableDataSource(this.entityList);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.log("Error: " + error);
      }
    );
  }

  handleInput(event) {
    if (event.which === 32 && !this.value.length) event.preventDefault();
  }
}
